import { IconComponent } from './types';

const ProjectionIcon: IconComponent<{ color?: string }> = ({
  color,
  ...props
}) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      d="m1.05 11.086 4.2-4.207 2.8 2.8L14 2.987 13.013 2 8.05 7.579l-2.8-2.8L0 10.036l1.05 1.05Z"
      fill={color || 'currentColor'}
    />
  </svg>
);

export default ProjectionIcon;
